import { Select, MenuItem } from "@mui/material";

type Props = {
  currentQuestion: any;
};

const DropdownPreview = ({ currentQuestion }: Props) => {
  const { choices } = currentQuestion;

  return (
    <div className="dropdown-preview">
      <Select fullWidth id="position" defaultValue={""}>
        {choices?.map((choice: any) => (
          <MenuItem key={choice?.id} value={choice.id}>
            {choice.label}
          </MenuItem>
        ))}
      </Select>
    </div>
  );
};
export default DropdownPreview;
